import React from 'react';
import { useNavigate } from 'react-router-dom';
import SubProductCard from '../../common/components/SubProductCard';

function RcProfessionaleSanitaQuotes() {
  const navigate = useNavigate();
  return (
    <>
      <div className="quote-group">
        <div className="quote-h1 text-center">
          <h1>RC Professionale Sanità</h1>
        </div>
        <div className="quote-h6">
          <h6>Cosa vuoi proteggere?</h6>
        </div>
      </div>
      <div className="container text-center select-product-one">
        <div className="row justify-content-center g-2 g-md-3 ">
          <SubProductCard
            product="Professioni Sanitarie"
            onSelect={() => {
              navigate('/quote/rc-professionale-sanita/professioni-sanitarie');
            }}
          />
          <SubProductCard
            product="Medici Liberi Professionisti"
            onSelect={() => {
              navigate('/quote/rc-professionale-sanita/medici-liberi-professionisti');
            }}
          />
          <SubProductCard
            product="Medici Dipendenti"
            onSelect={() => {
              navigate('/quote/rc-professionale-sanita/medici-dipendenti');
            }}
          />
          <SubProductCard
            product="Medico Dipendente e Libero Professionista"
            onSelect={() => {
              navigate('/quote/rc-professionale-sanita/medico-protetto');
            }}
          />
        </div>
      </div>
    </>
  );
}

export default RcProfessionaleSanitaQuotes;
